// extracted by mini-css-extract-plugin
export default {"form-section":"Form_form-section__5lmVr"};